import { render, staticRenderFns } from "./ManagerActivityItemNew.vue?vue&type=template&id=50f68ea5&scoped=true"
import script from "./ManagerActivityItemNew.vue?vue&type=script&lang=js"
export * from "./ManagerActivityItemNew.vue?vue&type=script&lang=js"
import style0 from "./ManagerActivityItemNew.vue?vue&type=style&index=0&id=50f68ea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f68ea5",
  null
  
)

export default component.exports